import { defineStore } from "pinia";

import drawLines from "@/assets/draw-lines.gif";
import type { BoardType } from "@/model/baseTypes";
import { isBacklogBoard, isObjectivesBoard } from "@/model/board";
import type { Line, LineComponent, RelativeCoordinate } from "@/model/coordinates";
import type { Shape } from "@/model/shape";

import { useToastStore } from "./toast";

interface DrawState {
  active: boolean;
  selected: SelectedShape | null;
}

type SelectedShape = { shape: Shape } & Selected;
export type Selected =
  | { anchor: LineComponent | null }
  | { anchor: "line"; offset: Line<RelativeCoordinate> };

export const useDrawStore = defineStore("draw", {
  state: (): DrawState => ({
    active: false,
    selected: null,
  }),
  getters: {
    isSupportedBoard() {
      return (boardType: BoardType) => !isObjectivesBoard(boardType) && !isBacklogBoard(boardType);
    },
  },
  actions: {
    toggle(active?: boolean) {
      this.active = active === undefined ? !this.active : active;
      this.updateSelected();
    },
    updateSelected() {
      if (this.active) {
        useToastStore().show(/*$t*/ "message.lineTool", {
          titleKey: /*$t*/ "action.lineTool",
          imageUrl: drawLines,
          closeable: true,
        });
      } else {
        this.selected = null;
      }
    },
  },
});
